import { endpoint } from 'services/Api';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'claims';

/**
 * Claim Endpoints:
 *     - Save
 *     - Load
 *     - Search
 */
export default {
    /**
     * Save a Claim with the Payload of Data.
     *
     * @param  {Object} data
     *
     * @return {Promise}
     */
    save: data => endpoint(RESOURCE, 'save', data),
    /**
     * Load a Claim by its ID.
     *
     * @param  {Integer} claimId
     *
     * @return {Promise}
     */
    load: claimId => endpoint(RESOURCE, 'load', { claim_id: claimId }),
    /**
     * Search Claims with Pagination
     *
     * @param  {Object} data Search Criteria
     * @param  {Integer} page Page (Pagination)
     *
     * @return {Promise}
     */
    search: (data, page, order, sort) => endpoint(RESOURCE, 'search', { data, page, order, sort }),
    /**
     * Delete a Claim by its ID.
     *
     * @param  {Integer} claimId
     *
     * @return {Promise}
     */
    delete: claimId => endpoint(RESOURCE, 'delete', { claim_id: claimId }),
    /**
     * Update a Claim.
     *
     * @param  {Integer} claimId
     *
     * @return {Promise}
     */
    update: data => endpoint(RESOURCE, 'update', data),
    /**
     * Update a Claim Costs.
     *
     * @param  {Integer} claimId
     *
     * @return {Promise}
     */
    updateCosts: data => endpoint(RESOURCE, 'costs', data),
};



// WEBPACK FOOTER //
// ./src/services/api/claims.js